import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-youtube",
  "use": "social-youtube-usage",
  "viewBox": "0 0 20 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 14\" id=\"social-youtube\">\n    <path d=\"M10.247 0c1.176.006 6.194.05 7.567.417.862.232 1.54.91 1.77 1.769C20 3.745 20 7 20 7s0 3.255-.417 4.814a2.509 2.509 0 0 1-1.769 1.77C16.255 14 10 14 10 14s-6.252 0-7.814-.417a2.509 2.509 0 0 1-1.77-1.769C.057 10.463.008 7.838.002 7.162v-.324c.006-.676.055-3.3.416-4.652.232-.862.91-1.54 1.769-1.77C3.562.05 8.578.007 9.753.002zM8.002 4v6l5.196-3-5.196-3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol